import React, { Component } from 'react';

// import { API, Auth } from "aws-amplify";

// import { Layout, Menu, Breadcrumb, Icon } from 'antd';
import { Card } from 'antd';
import { PageHeader } from 'antd'; 
// import { Button } from 'antd';

import ExerciseNewPageComponentContainer from '../../../components/pages/dashboard/exercises/ExerciseNewPageComponent';

// const { Header, Content, Footer, Sider } = Layout;
// const { SubMenu } = Menu;

class ExercisesNewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    // console.log(this.state);
    return (

      <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
        <PageHeader
          style={{
            paddingLeft: 0,
            borderBottom: '1px solid rgb(235, 237, 240)',
            marginBottom: 16
          }}
          title="Create New Exercise"
        />
        <Card
          style={{ minHeight: 360 }}
          title="Create a New Exercise Record"
        >
          <div style={{ paddingTop: 24 }}>
            <ExerciseNewPageComponentContainer />
          </div>
        </Card>
      </div>


    );
  }
}

export default ExercisesNewPage;
